<template>
  <div id="app">
    <NavBar v-if="currentUser.displayName && $router.currentRoute.path != '/login'"/>
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex';
const fb = require("./firebaseConfig.js");
import NavBar from '@/components/NavBar';
export default {
  components: {
    NavBar
  },
  computed: mapState(['currentUser']),
  beforeCreate() {
    if ((!this.$store.currentUser || !this.$store.currentUser.displayName) && fb.auth().currentUser) {
      fb.usersCollection.doc(fb.auth().currentUser.uid).get()
      .then((doc) => {
        if (doc.exists) {
          this.$store.commit('setCurrentUser', doc.data());
        } else {
          console.error("User doesn't exist");
          fb.auth().signOut().then(() => {
            this.$store.commit('setCurrentUser', {});
            this.$router.push('/');
          })
        }
      })      
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  a {
    text-decoration: none;
    &:visited {
      color: inherit;
    }
  }
}
</style>
